import { useState } from "react"
import { SimilarProducts, RelatedProducts, ProductsWithSameSerial } from "./AdditionalProducts"
import { MdOutlineKeyboardArrowUp } from 'react-icons/md';
import { useParams } from "../../../../Providers/ParamsProvider";

const OtherProducts = ({ product, productWidth }) => {
    const { isMobile } = useParams()
    const [isPopupSimilarVisible, setIsPopupSimilarVisible] = useState(false)
    const [isPopupSerialVisible, setIsPopupSerialvisible] = useState(false)
    const [isPopupRelatedVisible, setIsPopupRelatedVisible] = useState(false)

    const maxWidth = productWidth ? productWidth : '1000px'

    const togglePopupVisibility = (type) => {
        switch (type) {
            case 'Seria':
                setIsPopupSerialvisible(prevState => !prevState)
                setIsPopupSimilarVisible(false)
                setIsPopupRelatedVisible(false)
                return
            case 'Podobne':
                setIsPopupSimilarVisible(prevState => !prevState)
                setIsPopupSerialvisible(false)
                setIsPopupRelatedVisible(false)
                return
            case 'Powiazane':
                setIsPopupRelatedVisible(prev => !prev)
                setIsPopupSerialvisible(false)
                setIsPopupSimilarVisible(false)
                return
            default:
                setIsPopupSimilarVisible(false)
                setIsPopupSerialvisible(false)
                setIsPopupRelatedVisible(false)
        }
    }

    const arrowVisibility = isPopupSimilarVisible || isPopupSerialVisible || isPopupRelatedVisible ? '' : 'hidden'
    const relatedVisibility = product.hasRelated ? '' : 'collapse'
    const similarVisibility = product.hasSimilar ? '' : 'collapse'
    const seriesVisibility = product.hasSeries ? '' : 'collapse'
    //const hasSetVisibility = product.hasSet ? '' : 'collapse'

    if (!product.hasRelated && !product.hasSimilar && !product.hasSeries && !product.hasSet) {
        return null
    }
    return (
        <>
            <div className='col d-flex flex-column mt-2'>
                {isMobile && <div style={{ borderTop: '1px solid var(--border-color)', width: '100%' }} />}
                <div className="d-flex align-items-center">
                    <div className={`${arrowVisibility}`} style={{ width: '30px', cursor: 'pointer' }} onClick={togglePopupVisibility}>
                        <MdOutlineKeyboardArrowUp size={26} />
                    </div>
                    <div className={`d-flex flex-grow-1 justify-content-center`}>
                        {/* <div className={`${} products-additional me-3`}>Sprawdź w zestawie</div> */}
                        <div className={`${relatedVisibility} products-additional me-3 ${isPopupRelatedVisible ? 'active' : ''}`} onClick={() => togglePopupVisibility('Powiazane')}>Powiązane</div>
                        <div className={`${seriesVisibility} products-additional me-3 ${isPopupSerialVisible ? 'active' : ''}`} onClick={() => togglePopupVisibility('Seria')}>Seria</div>
                        <div className={`${similarVisibility} products-additional me-3 ${isPopupSimilarVisible ? 'active' : ''}`} onClick={() => togglePopupVisibility('Podobne')}>Podobne</div>
                    </div>
                </div>
            </div>
            <div className={`row additional ${isPopupSimilarVisible ? 'show' : 'hide'}`}>
                <div className='col'>
                    <div className='row'>
                        {isPopupSimilarVisible && <SimilarProducts product={product} isMobile={false} maxWidth={maxWidth} />}
                    </div>
                </div>
            </div>
            <div className={`row additional ${isPopupSerialVisible ? 'show' : 'hide'}`}>
                <div className='col'>
                    <div className='row'>
                        {isPopupSerialVisible && <ProductsWithSameSerial product={product} isMobile={false} maxWidth={maxWidth} />}
                    </div>
                </div>
            </div>
            <div className={`row additional ${isPopupRelatedVisible ? 'show' : 'hide'}`}>
                <div className='col'>
                    <div className='row'>
                        {isPopupRelatedVisible && <RelatedProducts product={product} isMobile={false} maxWidth={maxWidth} />}
                    </div>
                </div>
            </div>
        </>
    )
}

export default OtherProducts